import axios from "axios";
import dayjs from "dayjs";  

export const fetchOeeDashboardData = async () => {
    const response = await axios.get("api/api/getoeepershift");
    const oeeDashboardData = response.data;
    return oeeDashboardData;
}

export const fetchOeeDashboardDataTimeSpan = async (timeSpan,companyKey) => {
    const response = await axios.get("api/api/getoeetimespan/"+companyKey+"?timeSpan="+timeSpan);
    const oeeDashboardData = response.data;
    return oeeDashboardData;
}

export const fetchOeeGridDateIntervall = async(startDate,endDate,companyKey) => {
    const response = await axios.get("api/api/getoeedateintervall/"+companyKey+"?startDate="+dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")+"&endDate="+dayjs(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"));
    const oeeGridData = response.data;
    return oeeGridData;
}

export const updateMachinePriority = async (priority) => {
    return await axios.post(`api/api/updateMachinePriority/${priority.machineName}`,priority);
}

